/* bl-path.js — VISITOR PATHS (25 Sep 2026, Suhail's decision)
 * Records each visit's steps, in order, to /apps/chat/path (bb-chat worker, visitPath).
 * LINKED TO PEOPLE, on Suhail's explicit instruction (25 Sep 2026) — it does not wait for the
 * cookie banner, including for visitors who press Reject. See the note on visitPath in worker.js.
 *   · visit id  — random, sessionStorage (`bl_vid`), one per tab visit.
 *   · browser id — random, localStorage (`bl_bid`), persists: joins one browser's visits.
 *   · customer id — Shopify's, when the visitor is logged in.
 *   · bl-cdp id + Nitro id — when the browser has them (1 Oct 2026, "one address book"): the worker
 *     links this browser to the known person in the customer database (BLT_DB).
 *   · `_bl_vid` + `_bl_bid` are written onto the CART, so every order carries them.
 *   · Only the page PATH is sent, never the query string (search terms, tokens).
 * Steps: page (every page open) · atc (added to cart, with the product and size) · oos (tapped a
 * sold-out size) · fis (Find in Store) · offr (opened "view offers" on a product page, once per page)
 * · chk (a checkout / buy-now button) · hide (left the page or
 * switched away, with seconds on page and how far down it scrolled) · spd (how fast the page came up,
 * and the phone and connection it came up on — once per page, see 5 below) · err (a code error on
 * the page, up to 5 per page — see 6 below).
 * A/B TESTS (26 Sep 2026, Website → Tests in the admin): every beacon carries the visitor's group
 * from the bl_ab_pdp cookie (set by the bb-pdp-abtest worker, "<test id>.<A|B>"), and `_bl_ab` goes
 * on the CART beside _bl_vid/_bl_bid so orders carry it. Plus three ask-box steps on product pages:
 * askv (the ask box came at least half on screen, once per page) · askt (tapped it or typed into it,
 * once per page) · askq (a question sent to the chat, every one). The ask box is today's chip
 * (.bba-askchip) or anything a test version marks with data-bl-ask.
 * Never blocks anything: sendBeacon, and every failure is swallowed.
 */
(function () {
  try {
    if (window.__blPath || navigator.webdriver) return;
    window.__blPath = 1;
    var EP = '/apps/chat/path';
    var ss = null;
    try { ss = window.sessionStorage; ss.setItem('bl_path_t', '1'); } catch (e) { ss = null; }
    var get = function (k) { try { return ss ? ss.getItem(k) || '' : ''; } catch (e) { return ''; } };
    var set = function (k, v) { try { if (ss) ss.setItem(k, v); } catch (e) {} };

    var rid = function () {
      var a = new Uint8Array(20), s = '', i;
      if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(a);
      else for (i = 0; i < 20; i++) a[i] = Math.floor(Math.random() * 256);
      for (i = 0; i < 20; i++) s += (a[i] % 36).toString(36);
      return s;
    };
    var vid = get('bl_vid');
    if (!/^[a-z0-9]{20}$/.test(vid)) { vid = rid(); set('bl_vid', vid); }
    var bid = '';
    try { bid = localStorage.getItem('bl_bid') || ''; } catch (e) {}
    if (!/^[a-z0-9]{20}$/.test(bid)) { bid = rid(); try { localStorage.setItem('bl_bid', bid); } catch (e) {} }
    // Shopify puts the logged-in customer's id on every page; empty for guests.
    var cid = function () {
      try { return String((window.__st && window.__st.cid) || (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId) || ''); } catch (e) { return ''; }
    };
    // The visitor's A/B group, read fresh each time (the worker can set or clear it on any product
    // page). A ?ab=A|B preview sets no cookie, so a preview is never counted.
    var abArm = function () {
      try { var m = document.cookie.match(/(?:^|;\s*)bl_ab_pdp=(\d{1,9}\.[AB])(?:;|$)/); return m ? m[1] : ''; } catch (e) { return ''; }
    };
    // ONE ADDRESS BOOK (1 Oct 2026, his rule): the ids the customer database already knows this
    // browser by, so the worker can link this visit to a known person. `a` = bl-cdp's id (cookie
    // bl_aid, set by the bl-cdp tracker), `ni` = Nitro's id (published by nitro-consent-loader once
    // Nitro is ready, so often only on a later beacon). Read fresh each time; empty when unknown.
    var aidOf = function () {
      try { var m = document.cookie.match(/(?:^|;\s*)bl_aid=([0-9a-f-]{36})(?:;|$)/i); return m ? m[1] : ''; } catch (e) { return ''; }
    };
    var nidOf = function () {
      try { var n = window.__bl_nitro_ready && window.__bl_nitro_ready.nitroId; return /^[0-9a-f-]{36}$/i.test(String(n || '')) ? String(n) : ''; } catch (e) { return ''; }
    };

    // Campaign tags are read once, on the page the visit landed on.
    var land = null;
    try { land = JSON.parse(get('bl_path_land') || 'null'); } catch (e) { land = null; }
    if (!land) {
      var qs = null;
      try { qs = new URLSearchParams(location.search); } catch (e) {}
      var q = function (k) { try { return (qs && qs.get(k) || '').slice(0, 60); } catch (e) { return ''; } };
      // uc = utm_content (27 Sep 2026): tells apart Campaign links that differ only by message version,
      // influencer or store. A visit whose `land` was stored by an older copy of this file has no uc;
      // it is then left out of the beacon, and the worker keeps it NULL ("not recorded").
      // pl / ss (6 Oct 2026): where the Meta ad was seen — bl_pl={{placement}} (e.g. Instagram_Reels) and
      // bl_ss={{site_source_name}} (fb / ig / msg / an), added to the ads' URL parameters.
      land = { cm: q('utm_campaign'), us: q('utm_source'), um: q('utm_medium'), uc: q('utm_content'), pl: q('bl_pl'), ss: q('bl_ss') };
      set('bl_path_land', JSON.stringify(land));
    }

    // Where the visit came from. bl-attr.js decides this and stores it as `bl_first_ref`, but it can
    // run AFTER this file's first beacon (found in Chrome 25 Sep: the first page arrived with no
    // source), and a visit that bounces never sends a second one. So if the label is not there yet,
    // work it out here with bl-attr.js's EXACT rules (copied from its classify(), keep in step)
    // and store it under the same key — bl-attr.js then reads it back and agrees.
    var source = function () {
      var s = get('bl_first_ref');
      if (s) return s;
      var qs2 = null, ref = '';
      try { qs2 = new URLSearchParams(location.search); } catch (e) {}
      var g = function (k) { try { return qs2 && qs2.get(k) || ''; } catch (e) { return ''; } };
      if (g('gclid') || g('gad_source') || g('gbraid') || g('wbraid')) s = 'google-paid';
      else if (g('fbclid')) s = 'meta-paid';
      else if (g('utm_source')) s = 'utm:' + g('utm_source').toLowerCase().slice(0, 40);
      else {
        try { ref = document.referrer || ''; } catch (e) { ref = ''; }
        if (!ref) s = 'direct';
        else {
          var host = '';
          try { host = new URL(ref).hostname.toLowerCase(); } catch (e) { host = ''; }
          s = !host ? 'other' : host.indexOf('basicslife') !== -1 ? '' : /(^|\.)google\./.test(host) ? 'google-organic'
            : /(^|\.)(bing|duckduckgo|yahoo|ecosia|search\.brave)\./.test(host) ? 'search-organic'
            : /(chatgpt|openai|perplexity|gemini|claude|copilot)\./.test(host) ? 'ai:' + host.slice(0, 40)
            : /(facebook|instagram|fb\.|fbcdn|threads)\./.test(host) ? 'meta-organic'
            : /(youtube|whatsapp|t\.co|twitter|x\.com|linkedin|pinterest)\./.test(host) ? 'social:' + host.slice(0, 30)
            : 'ref:' + host.slice(0, 40);
        }
      }
      if (!s) s = 'direct';   // bl-attr.js: `now||(now="direct")`
      set('bl_first_ref', s);
      return s;
    };

    var CODE = /^[0-9]{0,2}B[A-Z]{2,3}[0-9]{4,6}$/;
    var codeOf = function (handle) {
      var c = String(handle || '').split('-').pop().toUpperCase();
      return CODE.test(c) ? c : '';
    };
    var pageType = function () {
      var p = location.pathname.toLowerCase();
      if (/\/products\//.test(p)) return 'pdp';
      if (p === '/' || p === '') return 'home';
      if (/^\/collections\/?$/.test(p)) return 'collections';
      if (/^\/collections\//.test(p)) return 'collection';
      if (/^\/search/.test(p)) return 'search';
      if (/^\/cart/.test(p)) return 'cart';
      if (/^\/pages\//.test(p)) return 'page';
      if (/^\/account/.test(p)) return 'account';
      if (/^\/blogs\//.test(p)) return 'blog';
      if (/^\/apps\//.test(p)) return 'app';
      return 'other';
    };
    var PT = pageType();
    var pageItem = PT === 'pdp' ? codeOf((location.pathname.match(/\/products\/([^/?#]+)/i) || [])[1]) : '';

    // CLARITY LABELS (6 Oct 2026, his ask "make maximum use of Clarity"): tell Clarity who this visit is in OUR
    // terms, so its recordings can be filtered by them and matched to our visit / order records:
    //   bl_vid (our visit id — order_attr.bl_vid joins it to an order), bl_src (where the visit came from),
    //   bl_ad (the ad id, utm_content), bl_pl / bl_ss (where the Meta ad was seen), bl_item (product code),
    //   bl_atc (set when something is added to cart). identify() = our browser id (pseudonymous, no PII).
    // Clarity's own snippet may load after this file, so it retries for up to ~10 s.
    var clTag = function (k, v) { try { if (v && typeof window.clarity === 'function') { window.clarity('set', k, String(v).slice(0, 60)); return true; } } catch (e) {} return false; };
    var clDone = false, clTries = 0;
    var clLabel = function () {
      if (clDone) return;
      if (typeof window.clarity !== 'function') { if (++clTries < 20) setTimeout(clLabel, 500); return; }
      clDone = true;
      try { window.clarity('identify', bid); } catch (e) {}
      clTag('bl_vid', vid); clTag('bl_src', source()); clTag('bl_ad', land.uc); clTag('bl_pl', land.pl);
      clTag('bl_ss', land.ss); clTag('bl_cm', land.cm); clTag('bl_item', pageItem);
    };
    clLabel();

    var seq = parseInt(get('bl_path_n'), 10) || 0;
    var queue = [];
    var ev = function (k, x) {
      seq++; set('bl_path_n', String(seq));
      var o = { k: k, n: seq, t: Date.now(), pt: PT };
      if (x) for (var a in x) if (x[a]) o[a] = x[a];
      queue.push(o);
    };
    var flush = function () {
      while (queue.length) {
        var body = JSON.stringify({ v: vid, b: bid, c: cid(), ch: source(), cm: land.cm, us: land.us, um: land.um, uc: land.uc, pl: land.pl, ss: land.ss, ab: abArm(), a: aidOf(), ni: nidOf(), ev: queue.splice(0, 25) });
        var sent = false;
        try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(EP, new Blob([body], { type: 'text/plain' }))); } catch (e) {}
        if (!sent) { try { fetch(EP, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {}); } catch (e) {} }
      }
    };

    // 1. The page itself — sent as soon as the page is ready, so a visit that bounces is still
    // recorded (in-app browsers often never fire pagehide). This file loads BEFORE the theme's
    // other scripts, so its add-to-cart hooks are in place before anything else keeps a copy of
    // fetch; waiting for DOMContentLoaded lets bl-attr.js set the source label first.
    // The link to the order: once the cart has something in it, it carries this visit's and this
    // browser's ids (the same way bl-attr.js puts `_bl_ref` on it). Only written when they differ,
    // so it is one cheap /cart.js read per page and rarely a write.
    // Breeze's checkout keeps its OWN cart token (localStorage "cartToken", saved as a JSON string), not
    // Shopify's, so the server needs both to tie a checkout to this browser (Identity Stitching, 18 Oct 2026).
    var bctNow = function () {
      var raw = '', t = '';
      try { raw = localStorage.getItem('cartToken') || ''; } catch (e) { return ''; }
      try { t = JSON.parse(raw || '""') || ''; } catch (e) { t = raw.replace(/"/g, ''); }
      t = String(t).split('?')[0];
      return /^[A-Za-z0-9]{16,40}$/.test(t) ? t : '';
    };
    var sendTok = function (ct, bct) {
      try {
        var bd = JSON.stringify({ v: vid, b: bid, ct: ct, bct: bct, ev: [] });
        if (!(navigator.sendBeacon && navigator.sendBeacon(EP, new Blob([bd], { type: 'text/plain' }))))
          fetch(EP, { method: 'POST', body: bd, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      } catch (e) {}
    };
    var cartSync = function () {
      try {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          if (!c || !c.item_count) return;
          // The cart's token, once per tab (Identity Stitching, 17 Oct 2026): an unfinished checkout carries the same
          // token, so the server can tie the mobile typed at checkout to this browser. The token only, never the ?key=.
          // Sent again whenever EITHER token changes (Breeze can make a new one on an old Shopify cart).
          var tk = String(c.token || '').split('?')[0], bt = bctNow();
          if ((tk && tk !== get('bl_ct')) || (bt && bt !== get('bl_bct'))) {
            if (tk) set('bl_ct', tk);
            if (bt) set('bl_bct', bt);
            sendTok(tk, bt);
          }
          var a = c.attributes || {}, ab = abArm();
          // The group is only ever ADDED, never cleared: a visitor whose test just stopped still bought
          // after seeing it, and the report only reads orders from inside the test's own dates.
          if (a._bl_vid === vid && a._bl_bid === bid && (!ab || a._bl_ab === ab)) return;
          var at = { _bl_vid: vid, _bl_bid: bid };
          if (ab) at._bl_ab = ab;
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: at }) }).catch(function () {});
        }).catch(function () {});
      } catch (e) {}
    };
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added'].forEach(function (n) {
      document.addEventListener(n, function () { setTimeout(cartSync, 80); });
    });
    var first = function () { ev('page', { u: location.pathname, i: pageItem }); flush(); cartSync(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', first);
    else first();

    // Breeze's CHECKOUT ID (Identity Stitching, 20 Oct 2026, his yes; Audit row 7): Breeze makes a brand-new cart when its
    // checkout opens, so neither cart token above ever matches. But the checkout puts ?atomsSt=<base64 JSON> in this page's
    // address, and its checkoutId is on the unfinished checkout too. Sent once per id. Reads the address only: no taps,
    // nothing on the Buy now / Checkout buttons, nothing waits on it.
    var bzNow = function () {
      try {
        var m = location.search.match(/[?&]atomsSt=([^&#]+)/);
        if (!m) return '';
        var s = decodeURIComponent(m[1]).replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
        while (s.length % 4) s += '=';
        var id = String((JSON.parse(atob(s)) || {}).checkoutId || '');
        return /^[A-Za-z0-9_-]{10,40}$/.test(id) ? id : '';
      } catch (e) { return ''; }
    };
    var bzSend = function () {
      try {
        var id = bzNow();
        if (!id || id === get('bl_bz')) return;
        set('bl_bz', id);
        var bd = JSON.stringify({ v: vid, b: bid, bz: id, ev: [] });
        if (!(navigator.sendBeacon && navigator.sendBeacon(EP, new Blob([bd], { type: 'text/plain' }))))
          fetch(EP, { method: 'POST', body: bd, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      } catch (e) {}
    };
    // Breeze can add it after the page has loaded (history.replaceState / pushState), so the address is watched too.
    try {
      ['pushState', 'replaceState'].forEach(function (k) {
        var o = history[k];
        if (typeof o !== 'function' || o.__blBz) return;
        var w = function () { var r = o.apply(this, arguments); setTimeout(bzSend, 0); return r; };
        w.__blBz = 1;
        history[k] = w;
      });
      window.addEventListener('popstate', bzSend);
    } catch (e) {}
    bzSend();

    // 2. Adds to cart. Every add in this theme goes through /cart/add (fetch or XHR); the answer
    // names the product and variant, so it works from any page, not just the product page.
    var sizeOf = function (it) {
      var o = it && it.options_with_values || [];
      for (var i = 0; i < o.length; i++) if (/size/i.test(o[i].name)) return String(o[i].value || '');
      var t = String(it && it.variant_title || '');
      return t.indexOf('/') !== -1 ? t.split('/').pop().trim() : '';
    };
    var added = function (j) {
      try {
        var items = j && j.items ? j.items : (j && j.handle ? [j] : []);
        clTag('bl_atc', '1');
        if (!items.length) ev('atc', { i: pageItem });
        for (var i = 0; i < items.length; i++) ev('atc', { i: codeOf(items[i].handle) || pageItem, s: sizeOf(items[i]) });
        flush();
        cartSync();
      } catch (e) {}
    };
    var isAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/i.test(String(u || '')); };
    // A question to the chat: bb-ask-basics.liquid (and the floating chat) POST to /apps/chat with a
    // "message". Feedback thumbs go to the same address WITHOUT one, and this file's own beacons go to
    // /apps/chat/path, so neither is counted.
    var isAsk = function (u, init) {
      try {
        var p = new URL(String(u || ''), location.href).pathname.replace(/\/$/, '');
        var b = init && init.body;
        return p === '/apps/chat' && typeof b === 'string' && /"message"\s*:/.test(b);
      } catch (e) { return false; }
    };
    if (window.fetch && !window.__blPathFetch) {
      window.__blPathFetch = 1;
      var _f = window.fetch;
      window.fetch = function () {
        var a0 = arguments[0], u = a0 && a0.url ? a0.url : String(a0 || '');
        try { if (isAsk(u, arguments[1])) { ev('askq', { i: pageItem }); flush(); } } catch (e) {}
        var pr = _f.apply(this, arguments);
        try {
          if (isAdd(u)) pr.then(function (r) { if (r && r.ok) r.clone().json().then(added).catch(function () { added(null); }); }).catch(function () {});
        } catch (e) {}
        return pr;
      };
    }
    if (window.XMLHttpRequest && !window.__blPathXhr) {
      window.__blPathXhr = 1;
      var _o = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) {
        try {
          if (isAdd(u)) this.addEventListener('load', function () {
            try { if (this.status >= 200 && this.status < 300) added(JSON.parse(this.responseText)); } catch (e) { added(null); }
          });
        } catch (e) {}
        return _o.apply(this, arguments);
      };
    }

    // 3. Taps: the ask box, sold-out size, Find in Store, and anything that starts checkout.
    var ASK = '.bba-askchip,[data-bl-ask]';
    var askTapped = false;
    var askTap = function () { if (askTapped || PT !== 'pdp') return; askTapped = true; ev('askt', { i: pageItem }); flush(); };
    // Option D's box is a text field: tapping into it to type counts as a tap.
    document.addEventListener('focusin', function (e) {
      try { if (e.target && e.target.closest && e.target.closest('[data-bl-ask]')) askTap(); } catch (x) {}
    }, true);
    var CHK = /check\s*out|place\s*order|buy\s*(it\s*)?now|proceed\s*to\s*pay/i;
    var offrTapped = false;
    document.addEventListener('click', function (e) {
      try {
        var el = e.target && e.target.closest ? e.target : null;
        if (!el) return;
        if (el.closest(ASK)) { askTap(); return; }
        var oos = el.closest('[data-bpdp-ab-oos]');
        if (oos) {
          // Same attribute the item counter reads (bb-store-avail.liquid, cntOos).
          ev('oos', { i: pageItem, s: (oos.getAttribute('data-size') || oos.textContent || '').trim().slice(0, 8) });
          return flush();
        }
        // Find in Store: the button, or a real tap on the In store tab (the button clicks that tab
        // itself, and that click is not trusted, so it is not counted twice) — as in cntOnce('fis').
        if (el.closest('[data-bpdp-find-store]') || (e.isTrusted && el.closest('.bb-t-tab[data-t="ins"]'))) {
          ev('fis', { i: pageItem }); return flush();
        }
        // 16 Oct 2026 (his yes, "does it help basket value"): the "Save up to ₹2,500 more — view offers"
        // button on product pages. Counted once per page (the first tap opens it; later taps only toggle).
        if (el.closest('[data-bpdp-ab-more]')) {
          if (!offrTapped) { offrTapped = true; ev('offr', { i: pageItem }); flush(); }
          return;
        }
        var b = el.closest('a,button,input[type=submit]');
        if (!b) return;
        var label = String(b.innerText || b.textContent || b.value || b.getAttribute('aria-label') || '').trim();
        var href = String(b.getAttribute('href') || '');
        if (b.name === 'checkout' || /\/checkout/.test(href) || CHK.test(label)) {
          ev('chk', { l: label.replace(/\s+/g, ' ').slice(0, 30) });
          flush();
          // Breeze may make a fresh token as checkout starts; send it if it changed (ct empty = Breeze token only).
          try { var bk = bctNow(); if (bk && bk !== get('bl_bct')) { set('bl_bct', bk); sendTok('', bk); } } catch (y) {}
        }
      } catch (x) {}
    }, true);

    // The ask box coming on screen (at least half of it), once per product page. Today's chip is
    // mounted late by bb-ask-basics.liquid (it waits for the size row), so look for it for a while.
    if (PT === 'pdp' && window.IntersectionObserver) {
      var askSeen = false, watched = [], tries = 0;
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting && !askSeen) { askSeen = true; ev('askv', { i: pageItem }); flush(); try { io.disconnect(); } catch (x) {} }
        }
      }, { threshold: 0.5 });
      var look = function () {
        try {
          var els = document.querySelectorAll(ASK);
          for (var i = 0; i < els.length; i++) if (watched.indexOf(els[i]) === -1) { watched.push(els[i]); io.observe(els[i]); }
        } catch (x) {}
      };
      look();
      var iv = setInterval(function () { look(); if (askSeen || ++tries > 20) clearInterval(iv); }, 500);
    }

    // 4. Leaving: seconds on the page (in the foreground) and deepest scroll, each time the page is
    // hidden. Coming back starts a new stretch, so the seconds add up without double counting.
    var t0 = Date.now(), deep = 0, hidden = false;
    var scrolled = function () {
      try {
        var h = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
        var p = h ? Math.round(((window.scrollY || 0) + window.innerHeight) / h * 100) : 0;
        if (p > deep) deep = Math.min(100, p);
      } catch (e) {}
    };
    window.addEventListener('scroll', scrolled, { passive: true });
    // 5. SPEED (30 Sep 2026, his yes 26 Sep): how fast this page came up and what it came up on, so
    // add-to-cart can be set against slow pages — compared within one phone type and one source, or
    // cheap phones on slow networks make the website look slower than it is. Sent ONCE per page:
    // 3 s after the page has finished loading, or when it is left, whichever comes first (in-app
    // browsers often never say "left", and bounces are the visits that matter most here).
    //   fb = server reply (ms from the tap to the first byte back) · cv = main content visible (the
    //   biggest picture or text block painted; Chrome/Android only, iPhones don't report it) ·
    //   dl = page usable (DOMContentLoaded) · ld = fully loaded (absent = left before it finished).
    //   Phone: os = ios / android / other · me = memory in GB · cp = processor cores · nt = connection
    //   (4g/3g/2g). me and nt are Chrome/Android only. Labels only, never the raw user agent.
    var lcp = 0, spdSent = false;
    try {
      if (window.PerformanceObserver) {
        new PerformanceObserver(function (l) { var es = l.getEntries(); if (es.length) lcp = es[es.length - 1].startTime; })
          .observe({ type: 'largest-contentful-paint', buffered: true });
      }
    } catch (e) {}
    var speed = function () {
      if (spdSent) return;
      spdSent = true;
      try {
        var ms = function (x) { x = Math.round(x || 0); return x > 0 && x < 120000 ? x : 0; };
        var fb = 0, dl = 0, ld = 0;
        var nv = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
        if (nv) { fb = ms(nv.responseStart); dl = ms(nv.domContentLoadedEventEnd); ld = ms(nv.loadEventEnd); }
        else if (performance.timing) {
          var tm = performance.timing, s0 = tm.navigationStart;
          fb = ms(tm.responseStart - s0); dl = ms(tm.domContentLoadedEventEnd - s0); ld = ms(tm.loadEventEnd - s0);
        }
        var ua = navigator.userAgent || '', cn = navigator.connection || {};
        // 11 Oct 2026 (Speed page, his yes): where the wait before the first answer goes — fs before fetching
        // started (app hand-off, redirects), dn name lookup, cn connecting incl. the secure handshake, rq when the
        // request went out; the server's own time is fb - rq. Sent as text so a real 0 (reused connection)
        // survives ev(), which drops empty values.
        var part = function (a, b) { a = Math.round(a || 0); b = Math.round(b || 0); return nv && b >= a && b - a < 120000 ? String(b - a) : ''; };
        // 26 Oct 2026 (PDP Speed, his yes): read the page's own timing label — og = Cloudflare→Shopify trip (bl-origin,
        // from our helper), pr = Shopify building the page (processing). Empty when the label isn't there.
        // fh = when the REAL page arrived: fb (responseStart) stops at Cloudflare's early hint (103), ~10 ms in.
        var stm = function (n) { var l = (nv && nv.serverTiming) || []; for (var j = 0; j < l.length; j++) if (l[j].name === n) { var d = Math.round(l[j].duration || 0); return d >= 0 && d < 120000 ? String(d) : ''; } return ''; };
        ev('spd', { og: stm('bl-origin'), pr: stm('processing'), fh: nv && nv.finalResponseHeadersStart > 0 ? part(0, nv.finalResponseHeadersStart) : '', u: location.pathname, i: pageItem, fb: fb, cv: ms(lcp), dl: dl, ld: ld,
          os: /iPhone|iPad|iPod/i.test(ua) ? 'ios' : /Android/i.test(ua) ? 'android' : 'other',
          me: navigator.deviceMemory, cp: navigator.hardwareConcurrency, nt: String(cn.effectiveType || '').slice(0, 8),
          fs: nv ? part(0, nv.fetchStart) : '', dn: nv ? part(nv.domainLookupStart, nv.domainLookupEnd) : '',
          cn: nv ? part(nv.connectStart, nv.connectEnd) : '', rq: nv && nv.requestStart > 0 ? part(0, nv.requestStart) : '' });
        flush();
      } catch (e) {}
    };
    var spdLater = function () { setTimeout(speed, 3000); };
    if (document.readyState === 'complete') spdLater();
    else window.addEventListener('load', spdLater);

    // 6. CODE ERRORS (1 Oct 2026, step 4 of "who we know", his yes): a script that fails during the
    // visit is written onto the visit, so "did errors cost orders" can be answered for every visit and
    // "who got it" for the people we recognise. Up to 5 per page. What is sent: the message (web
    // addresses cut to host + path, e-mail addresses and long numbers masked), the file (path only)
    // and line, and the page path. A picture or script that fails to LOAD is not a code error and is
    // skipped. Errors the theme already treats as noise (the iPhone autofill one, layout/theme.liquid)
    // are stopped before they reach here.
    var errN = 0;
    // 11 Oct 2026 (Clarity No. 2): Safari writes stack lines as "fn@https://basicslife.com/collections/x:3:4394",
    // and the e-mail mask turned "fn@basicslife.com" into "email" — the function name, the only clue, was lost.
    // Now "fn @ /collections/x:3:4394": our own address drops to the path, and the spaces keep the e-mail mask
    // (here and again in the worker) off it. Real e-mail addresses are still masked.
    var clean = function (s, n) {
      return String(s || '').replace(/@(?=https?:\/\/)/g, ' @ ')
        .replace(/https?:\/\/[^\s'"<>]+/g, function (u) { try { var x = new URL(u); return (x.host === location.host ? '' : x.host) + x.pathname; } catch (e) { return 'url'; } })
        .replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, 'email').replace(/\d{7,}/g, 'N').slice(0, n);
    };
    // 11 Oct 2026 (Clarity No. 2, asked by the Website design chat, his yes): name the script that was running
    // when the error was thrown. The iPhone "readonly property" error points at line 3 of the page itself, i.e.
    // code some app adds while the page runs. document.currentScript is that script while it runs: its file, or
    // for code written into the page its opening tag + first 80 characters, and whether it was added after the
    // page was built (not in the page when this tracker started). Sent at the start of the stack (st), so the
    // worker needs no change.
    var known = [];
    try { known = Array.prototype.slice.call(document.scripts); } catch (e) {}
    var scriptOf = function () {
      try {
        var s = document.currentScript;
        if (!s) return '';
        var tag = String(s.outerHTML || '').split('>')[0].slice(0, 120) + '>';
        var what = s.src ? 'file ' + fileOf(s.src) : 'inline ' + tag + ' ' + String(s.text || '').replace(/\s+/g, ' ').trim().slice(0, 80);
        return what + (known.indexOf(s) === -1 ? ' (added after the page was built)' : '');
      } catch (e) { return ''; }
    };
    var fileOf = function (f) {
      try { if (!f) return ''; var x = new URL(String(f), location.href); return (x.host === location.host ? '' : x.host) + x.pathname; } catch (e) { return ''; }
    };
    // 6 Oct 2026 (Clarity problems 2 and 3, Changes to make #5): also send the first lines of the error's
    // stack (st), so an error whose "file" is the page itself can be named to the script that threw it; the
    // address of a fetch that failed, for "Failed to fetch" / "Load failed"; and files that came back 400+
    // ("not found 404", Chrome only — Safari doesn't give the status). Same masking as the message.
    var onErr = function (msg, file, line, col, stack) {
      if (errN >= 5 || !msg) return;
      errN++;
      var sc = scriptOf();
      ev('err', { m: clean(msg, 150), f: clean(fileOf(file), 120), ln: line, cl: col, u: location.pathname, i: pageItem,
        st: clean((sc ? 'script: ' + sc + '\n' : '') + (stack || ''), 400) });
      flush();
    };
    var lastFail = null;
    try {
      var of = window.fetch;
      if (of && !of.__blp) {
        var wf = function (input) {
          var fu = '';
          try { fu = typeof input === 'string' ? input : (input && input.url) || ''; } catch (x) {}
          return of.apply(this, arguments).catch(function (err) { lastFail = { u: fu, t: Date.now() }; throw err; });
        };
        wf.__blp = 1;
        window.fetch = wf;
      }
    } catch (x) {}
    window.addEventListener('error', function (e) {
      try {
        if (e && e.target && e.target !== window && !e.message) return;
        onErr(e.message || (e.error && e.error.message), e.filename, e.lineno, e.colno, e.error && e.error.stack);
      } catch (x) {}
    });
    window.addEventListener('unhandledrejection', function (e) {
      try {
        var r = e && e.reason, m = r && r.message ? r.message : String(r), f = r && r.fileName;
        if (!f && lastFail && Date.now() - lastFail.t < 2000 && /fetch|load failed|network/i.test(m)) f = lastFail.u;
        onErr('promise: ' + m, f, r && r.lineNumber, 0, r && r.stack);
      } catch (x) {}
    });
    try {
      if (window.PerformanceObserver) new PerformanceObserver(function (l) {
        l.getEntries().forEach(function (en) { if (en.responseStatus >= 400) onErr('not found ' + en.responseStatus, en.name, 0, 0, ''); });
      }).observe({ type: 'resource', buffered: true });
    } catch (x) {}

    var hide = function () {
      if (hidden) return;
      speed();
      hidden = true; scrolled();
      ev('hide', { d: Math.round((Date.now() - t0) / 1000), sc: deep });
      flush();
    };
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') hide();
      else if (hidden) { hidden = false; t0 = Date.now(); }
    });
    window.addEventListener('pagehide', hide);
  } catch (e) {}
})();
